module.exports = __webpack_public_path__ + "img/06.b46b8001.png";